const Nearby = (props) => {
  return (
    <section className="nearby-sec">
      <div className="sec-header">
        <i className="icon-index icon-index-nearby"></i>
        <div className="sec-label">附近主播</div>
      </div>
      <div className="star-list-wrap">
        <div className="star-list clearfix"></div>
        <div className="mask mask-left">
          <div className="arrow arrow-left" data-action="left">
            <i className="icon-index icon-index-nearby-arrow-left"></i>
          </div>
        </div>
        <div className="mask mask-right">
          <div className="arrow arrow-right" data-action="right">
            <i className="icon-index icon-index-nearby-arrow-right"></i>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Nearby;
